<template>
  <div>
    <div class="content-6">
      <div class="reference">
        <div class="title">参考文献</div>
        <div class="r-content">
          <div class="r-item" v-for="(item, index) in reference" :key="index">{{
            item
          }}</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <img
        id="nav-id-2"
        class="bottom-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/82926e668d8d02994096621a1d4366df.png"
        alt=""
      />
      <img class="qrcode" :src="qrcode" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  computed: {
    reference() {
      return JSON.parse(this.info.queDetail.reference)
    }
  },
  data() {
    return {
      qrcode:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8d141f9cdf992afac4caaf2360ba950e.png',
      qrcodeData: [
        {
          name: '【坚果卡】体验周卡',
          card_type_first_level: 1,
          card_type_second_level: 2,
          qrcode:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0e0a33b9e95694ac9b4e97c45cb49ebc.png'
        },
        {
          name: '【桑葚卡】体验周卡',
          card_type_first_level: 2,
          card_type_second_level: 2,
          qrcode:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f553dada70722ca028198b29bf6ae481.png'
        },
        {
          name: '【苹果卡】体验周卡',
          card_type_first_level: 3,
          card_type_second_level: 2,
          qrcode:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c95fcc6f084d0bd9dca50425b7b35784.png'
        },
        {
          name: '【燕麦卡】体验周卡',
          card_type_first_level: 4,
          card_type_second_level: 2,
          qrcode:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/73ddefcb2d18622657d26cfdde332e84.png'
        },
        {
          name: '【黄豆卡】体验周卡',
          card_type_first_level: 5,
          card_type_second_level: 2,
          qrcode:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d477548e031b27e41ec16ae1343fc176.png'
        },
        {
          name: '【黑芝麻卡】体验周卡',
          card_type_first_level: 6,
          card_type_second_level: 2,
          qrcode:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4a1a68aca5898c6b9635c2b7e5b8b178.png'
        }
      ]
    }
  },
  created() {
    this.getVipInfo()
  },
  methods: {
    getVipInfo() {
      this.$http
        .getBaseApp('api/v3/WeplusData/getUserWeplusIdentify', {})
        .then((res) => {
          res = res.data
          this.cardInfo = res.data
        })
    },
    //跳转客服
    getQrcode() {
      let info = this.cardInfo?.weplus_info
      if (info && info.card_type_first_level && info.type_id == 4) {
        let item = this.qrcodeData.find((item) => {
          return item.card_type_first_level == info.card_type_first_level
        })
        if (item?.qrcode) {
          this.qrcode = item.qrcode
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content-6 {
  width: 335px;
  padding: 20px;
  margin: 0 auto 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;

  .reference {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.4);

    .title {
      margin-bottom: 10px;
    }

    .r-content {
      .r-item {
        margin-bottom: 8px;
      }

      .r-item:last-child {
        margin-bottom: 0px;
      }
    }
  }
}

.bottom-image {
  width: 100%;
}

.bottom {
  position: relative;

  .qrcode {
    position: absolute;
    right: 28px;
    bottom: 28px;
    width: 120px;
    height: 120px;
    border: 4px solid rgb(237, 234, 255);
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
